import XLRLogger from 'src/common/helpers/logger';
import { store } from '../../common/redux/configure-store';
import { PluMenuActions } from '../../common/redux/reducers/plu-menu-reducer';
import { pluMenuConfigurationLookup } from './service/menu-configuration-lookup';

export const getPLUmenu = async (): Promise<void> => {
  const localTimeStamp = store.getState().pluMenu.consumableGroup.timeStamp;

  await pluMenuConfigurationLookup(localTimeStamp)
    .then((data): void => {
      if (data.timeStamp || !localTimeStamp) {
        store.dispatch(PluMenuActions.setPluMenu(data));
      }
    })
    .catch((err): void => {
      XLRLogger.error({
        message: '',
        data: err,
        source: 'get-plu-menu.ts',
      });
    });
};
